import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import axios from "axios";
import { reportSpecialUnitsTypes } from "redux/reducers/Reports/reportSpecialUnits/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";

const { SET_SPECIAL_UNITS_FILTERS } = reportSpecialUnitsTypes;

export const getReportSpecialUnitsAction = ({ startDate, customer, isPdf = true }) => {
  return async (dispatch, getState) => {
    dispatch(startRequestComp('loadingReportSpecialUnits'));
    try {
      const token = getState().login.token || localStorage.getItem('crm-user');
      const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/reports/special-units?date=${startDate}&idCustomer=${customer?.idCustomer || ''}&pdf=${isPdf}`;
      const fileName = `Reporte_UnidadesEspeciales_${startDate}.${isPdf ? "pdf" : "xlsx"}`;

      const file = await axios({
        url: reportUrl,
        method: 'GET',
        responseType: 'blob',
        headers: { authorization: token }
      });

      saveAs(file.data, fileName);
      dispatch(setSnackbar("Reporte descargado con éxito", "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingReportSpecialUnits'));
    }
  };
};

export const setReportSpecialUnitsFilters = (key = "", value) => ({
  type: SET_SPECIAL_UNITS_FILTERS,
  payload: { key, value }
});
